import { axiosInstanceNoToken } from "./axiosConfig";
import { isAxiosError } from "axios";

// INTERFACE_DOCUMENT
interface Document {
    id: string;
    document_type: string;
    content: string
}

// INTERFACE_SUCCESS_RESPONSE
interface DocumentsSuccessResponse {
    data: Document[];
    message?: string;
}

// VALIDATION_ERROR
interface ErrorDetail {
    code: string;
    detail: string;
    attr: string;
}

// GENERIC_ERROR_RESPONSE
interface GenericErrorResponse {
    error?: string;
}

// INTERFACE_ERROR_RESPONSE
interface DocumentsErrorResponse {
    type: 'validation_error';
    errors: ErrorDetail[];
}

// INTERFACE_RESULT
interface DocumentsResult {
    data: DocumentsSuccessResponse | DocumentsErrorResponse | GenericErrorResponse;
    status: number;
}

// GET DOCUMENTS API
export const GetDocuments = async (
): Promise<DocumentsResult> => {
    try {
        const response = await axiosInstanceNoToken.get<DocumentsSuccessResponse>(
            '/core/documents',

        );

        return {
            data: response.data,
            status: response.status
        };

    } catch (error) {
        if (isAxiosError(error)) {
            // HTTP ERROR
            if (error.response) {
                return {
                    data: error.response.data || { error: 'Bilinməyən xəta baş verdi' },
                    status: error.response.status
                };
            }

            // Network error
            if (error.request) {
                return {
                    data: { error: 'Şəbəkə xətası - cavab alınmadı' },
                    status: 0
                };
            }
        }

        // Another error
        return {
            data: {
                error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
            },
            status: -1
        };
    }
};